module.exports = __webpack_public_path__ + "img/active1.25c329fe.jpg";